import { Component, inject } from '@angular/core';
import { WoodCertificationDetailTypeService } from '../proxy/geographic/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  WoodCertificationDetailTypeCreateDto,
  WoodCertificationDetailTypeDto,
  WoodCertificationDetailTypeExcelDownloadDto,
  WoodCertificationDetailTypeUpdateDto,
} from '../proxy/geographic/dtos/wood-certification-detail-type';
import { WOODCERTIFICATIONDETAILTYPE_CONFIG, WOODCERTIFICATIONDETAILTYPE_FIELDS } from './wood-certification-detail-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-wood-certification-detail-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, WoodCertificationDetailTypeService, ConfirmationService],
  templateUrl: './wood-certification-detail-type.html',
  styleUrl: './wood-certification-detail-type.scss',
})
export class WoodCertificationDetailType extends BaseCrudComponent<
  WoodCertificationDetailTypeDto,
  WoodCertificationDetailTypeCreateDto,
  WoodCertificationDetailTypeUpdateDto,
  WoodCertificationDetailTypeExcelDownloadDto
> {
  service = inject(WoodCertificationDetailTypeService);
  config = WOODCERTIFICATIONDETAILTYPE_CONFIG;
  fields = WOODCERTIFICATIONDETAILTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: WoodCertificationDetailTypeDto): WoodCertificationDetailTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'WoodCertificationDetailType';
  }
}
